'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndFlag } from '../../Entities/Ind/IndFlag';
import { IndFlagCollection } from '../../Collections/Ind/IndFlagCollection';

export class IndFlagRepository extends CoreRepository {
  public addIndsFlag(individualIds: number[]) {
    return this.webAPI.addIndsFlag(individualIds).then((response) => {
      return response;
    });
  }

  public deleteIndsFlag(individualIds: number[]) {
    return this.webAPI.deleteIndsFlag(individualIds).then((response) => {
      return response;
    });
  }
}
